const E = {
  title: 'Customer Portal Login',
  sub: 'Secure access to your results and more',
  form: {
    region: {
      label: 'Region',
      error: 'Please select a region',
    },
    email: {
      label: 'Email Address',
      error: 'Invalid email format',
    },
    password: { label: 'Password', error: 'Password is a required field' },
    buttons: {
      login: 'login',
    },
  },
  links: {
    forgot: 'Forgot Password?',
    register: 'Register a New Account',
  },
};

const F = {
  title: 'Connexion au Portail Client',
  sub: 'Accès sécurisé à vos résultats et plus encore',
  form: {
    region: {
      label: 'Région',
      error: 'Veuillez choisir une région',
    },
    email: {
      label: 'Adresse courriel',
      error: 'Le format de l’adresse de courrier électronique est inexact.',
    },
    password: {
      label: 'Mot de passe',
      error: 'Le mot de passe est un champ obligatoire',
    },
    buttons: {
      login: 'Connexion',
    },
  },
  links: {
    forgot: 'Vous avez oublié votre mot de passe ?',
    register: 'Créer un nouveau compte',
  },
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/login.js